<template>
    <div id="Schedule_Visit">
        <ScheduleVisitHomeCare
            v-if="options.Application == applicationEnum.HomeCare"
            :visit-details="options"
            :is-loading="isLoading"
            :is-saving="isSaving"
            v-on:loadingChange="handleLoadingChange"
            v-on:savingChange="handleSavingChange"
            :cancel="cancel"
            :ok="ok"
            :add-another="addAnother"
        />

        <ScheduleVisitHosPal
            v-if="
                options.Application == applicationEnum.AxxessHospiceFE ||
                options.Application == applicationEnum.AxxessHospice ||
                options.Application == applicationEnum.AxxessPalliative
            "
            :visit-details="options"
            :is-loading="isLoading"
            :cancel="cancel"
            :ok="ok"
            :add-another="addAnother"
        />

        <ScheduleVisitHomeHealth
            v-if="options.Application == applicationEnum.AgencyCore"
            :visit-details="options"
            :is-loading="isLoading"
            :is-saving="isSaving"
            v-on:loadingChange="handleLoadingChange"
            v-on:savingChange="handleSavingChange"
            :cancel="cancel"
            :ok="ok"
            :add-another="addAnother"
        />
    </div>
</template>
<script lang="ts" src="./ScheduleVisitEmployee.ts"></script>
